import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Badge,
} from '@mui/material';
import {
  Notifications,
  Language,
  Sync,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { SUPPORTED_LANGUAGES } from '../../config/constants';

const AdminHeader: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleLanguageMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    handleLanguageMenuClose();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
        {t('admin.dashboard')} - {user?.name}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* Sync Status */}
        <IconButton color="inherit" aria-label="sync status">
          <Badge badgeContent={1} color="warning">
            <Sync />
          </Badge>
        </IconButton>

        {/* Language Toggle */}
        <IconButton
          color="inherit"
          onClick={handleLanguageMenuOpen}
          aria-label="change language"
        >
          <Language />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleLanguageMenuClose}
        >
          <MenuItem
            onClick={() => handleLanguageChange(SUPPORTED_LANGUAGES.ID)}
            selected={i18n.language === SUPPORTED_LANGUAGES.ID}
          >
            {t('language.indonesian')}
          </MenuItem>
          <MenuItem
            onClick={() => handleLanguageChange(SUPPORTED_LANGUAGES.EN)}
            selected={i18n.language === SUPPORTED_LANGUAGES.EN}
          >
            {t('language.english')}
          </MenuItem>
        </Menu>

        {/* Notifications */}
        <IconButton color="inherit" aria-label="notifications">
          <Badge badgeContent={5} color="error">
            <Notifications />
          </Badge>
        </IconButton>
      </Box>
    </Box>
  );
};

export default AdminHeader;